import { Fragment } from "react";
import type { ReadMessageBody } from "@ferrivia/api-contract";
import { useTranslation } from "@ferrivia/i18n";
import s from "./MessageBlocks.module.css";

export interface MessageBlocksProps {
  body: ReadMessageBody;
}

/**
 * Forward-compat renderer: pairs with the permissive readMessageBodySchema.
 * An unknown block type falls back to a muted line instead of throwing, so a
 * message using a block type this build doesn't know about still displays.
 */
export function MessageBlocks({ body }: MessageBlocksProps) {
  const { t } = useTranslation("chat");
  return (
    <>
      {body.blocks.map((block, index) => (
        <Fragment key={index}>
          {block.type === "text" ? (
            <span>{(block as { text: string }).text}</span>
          ) : (
            <span className={s.fallback}>{t("blocks.unsupported", "Tätä viestiä ei voi näyttää tässä versiossa.")}</span>
          )}
        </Fragment>
      ))}
    </>
  );
}
